
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

//import firebase from "firebase";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/firestore"
import "firebase/compat/messaging"
import "firebase/compat/app-check"
//import "firebase/compat/messaging"



const config = {

    apiKey: "AIzaSyDkWKPDyvX2qb2m3u2y71J2Bv2zeNygUyw",
    authDomain: "midwifeandnurse.firebaseapp.com",
    databaseURL: "https://midwifeandnurse-default-rtdb.firebaseio.com",
    projectId: "midwifeandnurse",
    storageBucket: "midwifeandnurse.firebasestorage.app",
    messagingSenderId: "545844420979",
    appId: "1:545844420979:web:5fc6a85c61dab6e3d52506",
    measurementId: "G-FWC8DV9P9P"

};



firebase.initializeApp(config);
// const db=firebase.database();
export const db = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();



//export const auth = firebase.auth();
//export const firestore = firebase.firestore()
//export const firebases = firebase;
// serviceWorkerRegistration: navigator.serviceWorker.register('https://boomsoftware.github.io/BoomDisplayAdmin/firebase-messaging-sw.js')